import { RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@ascleo/ui/components/ui/button";
import { replayActiveGuidance } from "../lib/audio";
import { useAudioPlaybackSnapshot } from "../lib/use-audio-playback-snapshot";

/**
 * Accessible header action that replays only the active spoken guidance.
 *
 * @since 1.2.0
 * @example
 * ```tsx
 * <AudioReplayButton />
 * ```
 */
export function AudioReplayButton() {
  const { t } = useTranslation();
  const { replayAvailable } = useAudioPlaybackSnapshot();
  const label = replayAvailable
    ? t("self-service.audio-guide.replay")
    : t("self-service.audio-guide.replay-unavailable");

  return (
    <Button
      data-testid="audio-guide-replay"
      type="button"
      variant="outline"
      size="lg"
      disabled={!replayAvailable}
      aria-label={label}
      title={label}
      onClick={(event) => {
        event.preventDefault();
        replayActiveGuidance();
      }}
    >
      <RotateCcw className="size-6" />
      {/* The visible label stays constant so the header does not reflow when
          replay becomes (un)available; the disabled styling plus the
          accessible name carry the reason. */}
      <span className="ml-2 hidden @4xl/kiosk-header:inline">
        {t("self-service.audio-guide.replay")}
      </span>
    </Button>
  );
}
